<template>
	<button
		type="button"
		class="p-1 shrink-0 inline-flex"
		:class="{ active: isActive, 'bg-indigo-200 rounded-md': isActive }"
		@click="onClick"
		:title="$t('Bullet list')"
		tabindex="-1"
	>
		<ListBulletIcon class="w-5 h-5" />
	</button>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { Editor } from "@tiptap/vue-3";
import { ListBulletIcon } from "@heroicons/vue/24/outline";

export default defineComponent({
	name: "BulletListButton",
	components: { ListBulletIcon },
	props: {
		editor: { type: Object as PropType<Editor | null | undefined>, required: true },
	},
	computed: {
		isActive(): boolean {
			return !!(this.editor as any)?.isActive?.("bulletList");
		},
	},
	methods: {
		onClick() {
			(this.editor as any)?.chain?.().focus().toggleBulletList().run();
		},
	},
});
</script>
